import BlogItem from "../../Components/blog/blog-item";

const Blog = () => {
  return (
    <>
      <BlogItem />
      <BlogItem />
      <BlogItem />
      <BlogItem />
      <BlogItem />
      <BlogItem />
      <BlogItem />
    </>
  );
};

export default Blog;
